import React, { useState } from 'react'

function Top() {

    const [activeFaq, setActiveFaq] = useState({});

    const faqs = [
        {
            id: 1,
            question: 'How can I pay?',
            answer: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry lorem Ipsum has. been the industrys standard dummy text ever since the when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five cen turies but also the leap into electronic typesetting, remaining essentially unchanged.'
        },
        {
            id: 2,
            question: 'How to setup account?',
            answer: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry lorem Ipsum has. been the industrys standard dummy text ever since the when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five cen turies but also the leap into electronic typesetting, remaining essentially unchanged.'
        },
        {
            id: 3,
            question: 'What is process to get refund?',
            answer: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry lorem Ipsum has. been the industrys standard dummy text ever since the when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five cen turies but also the leap into electronic typesetting, remaining essentially unchanged.'
        },
        {
            id: 4,
            question: 'What is process to get refund?',
            answer: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry lorem Ipsum has. been the industrys standard dummy text ever since the when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five cen turies but also the leap into electronic typesetting, remaining essentially unchanged.'
        },
        {
            id: 5,
            question: 'Can I get code bug support for customization?',
            answer: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry lorem Ipsum has. been the industrys standard dummy text ever since the when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five cen turies but also the leap into electronic typesetting, remaining essentially unchanged.'
        },
        {
            id: 6,
            question: 'Lorem Ipsum is simply dummy text of the printing and typesetting?',
            answer: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry lorem Ipsum has. been the industrys standard dummy text ever since the when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five cen turies but also the leap into electronic typesetting, remaining essentially unchanged.'
        },
        {
            id: 7,
            question: 'Lorem Ipsum is simply dummy text of the printing and typesetting?',
            answer: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry lorem Ipsum has. been the industrys standard dummy text ever since the when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five cen turies but also the leap into electronic typesetting, remaining essentially unchanged.'
        }
    ];

    const handleToggle = (id) => {
        setActiveFaq({ ...activeFaq, [id]: !activeFaq[id] });
    }

    return (
        <>
            <section className="row_am faq_section">
                <div className="container">
                    <div className="faq_panel">
                        <div className="accordion" id="accordionExample">
                            {faqs.map((faq) => (
                                <div className="card" data-aos="fade-up" key={faq.id}>
                                    <div className="card-header" id={`heading${faq.id}`}>
                                        <h2 className="mb-0">
                                            <button type="button" className={`btn btn-link ${activeFaq[faq.id] && "active"}`} onClick={() => handleToggle(faq.id)} data-toggle="collapse" data-target={`#collapse${faq.id}`}>
                                                {activeFaq[faq.id] ? <i className="icon_faq icofont-minus"></i> : <i className="icon_faq icofont-plus"></i>}
                                                {faq.question}
                                            </button>
                                        </h2>
                                    </div>
                                    <div id={`collapse${faq.id}`} className={`collapse ${activeFaq[faq.id] && "show"}`} aria-labelledby={`heading${faq.id}`} data-parent="#accordionExample">
                                        <div className="card-body">
                                            <p>{faq.answer}</p>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Top;